import { z } from 'zod';
import { isoDateSchema, objectIdSchema } from './common.js';
export const ADMIN_ROLES = ['ADMIN', 'EDITOR'];
export const adminRoleSchema = z.enum(ADMIN_ROLES);
export const adminLoginBodySchema = z.object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(8).max(200),
});
export const adminResponseSchema = z.object({
    id: objectIdSchema,
    email: z.string(),
    name: z.string(),
    role: adminRoleSchema,
    createdAt: isoDateSchema,
});
export const adminSessionResponseSchema = z.object({
    accessToken: z.string(),
    expiresAt: isoDateSchema,
    admin: adminResponseSchema,
});
//# sourceMappingURL=admin.js.map